import { useState } from "react";
import "./GmailBanner.css";

export const GmailBanner = () => {
  return (
    <div id="gmail-banner">
      <div className="gmail-banner-title">Gmail Plugin</div>
      <div className="gmail-banner-body">
        Get answers from inside of Gmail with our Chrome extension!
      </div>
      <div className="gmail-banner-cta">
        <div className="gmail-banner-cta-inner">
          <div className="gmail-banner-logo">
            <img src="/icons/chromeextension.png" />
          </div>
          <div className="gmail-banner-cta-text">Install Free Extension</div>
        </div>
      </div>
    </div>
  );
};
